<template>
    <div class="Interview">
        <div class="interviewBox">
            <div class="title">{{ title }}</div>
            <div class="listBox">
                <div @click="itemClick(item)" :key="item.id" v-for="item in list" class="listItem">
                    <img :src="item.cover" alt="" />
                    <div class="infoBox">
                        <div class="itemName">
                            {{ item.title }}
                        </div>
                        <div class="footBox">
                            <div class="address">
                                <img class="icon" src="@/assets/index/addressIcon.png" alt="" />
                                <div class="addressText">
                                    {{ item.address }}
                                </div>
                            </div>
                            <div class="date">{{ item.date }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="newsPagination">
            <myPagination @current-change="pageChange" :allNum="total" :page="query.page" :limit="query.limit">
            </myPagination>
        </div>
    </div>
</template>

<script>
import myPagination from '@/components/myPagination.vue'
import {
    get_list2,
    get_list2_detail
} from "@/api/partners.js"
export default {
    components: {
        myPagination,
    },
    data() {
        return {
            text: '',
            total: 0,
            query: {
                page: 1,
                limit: 6,
            },
            title: '',
            list: [],
        }
    },
    created() {
        this.getListData()
    },
    mounted() {

    },
    methods: {
        getListData() {
            get_list2().then(res => {
                this.title = res.data.title
                this.list = res.data.list
            })
        },
        pageChange(page) {
            this.query.page = page
            this.getListData()
        },
        itemClick(data) {
            let { id } = data
            let lang = this.$i18n.locale == 'zh' ? 'cn' : 'en'
            this.$router.push({
                path: `/${lang}/newsDetail`,
                query: {
                    id
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
.Interview {
    background: #ffffff;
    padding-bottom: 118px;
    padding-top: 118px;

    .interviewBox {
        width: 1200px;
        margin: auto;

        .title {
            font-size: 40px;
            color: #010101;
            line-height: 36px;
            font-weight: bold;
        }

        .listBox {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 50px;

            .listItem {
                width: 584px;
                margin-bottom: 30px;
                cursor: pointer;

                img {
                    width: 100%;
                    height: 330px;
                    object-fit: cover;
                    display: block;
                }

                .infoBox {
                    background: #F7F7F7;
                    padding: 40px 30px 30px 30px;

                    .itemName {
                        font-size: 24px;
                        color: #010101;
                        line-height: 28px;
                        padding-bottom: 23px;
                        font-weight: bold;
                    }

                    .footBox {
                        border-top: 1px solid #888888;
                        display: flex;
                        justify-content: space-between;
                        padding-top: 24px;

                        .address {
                            display: flex;
                            align-items: center;

                            .icon{
                                width: 24px;
                                height: 31px;
                                vertical-align: bottom;
                                margin-right: 8px;
                            }

                            .addressText {
                                font-size: 22px;
                                color: #010101;
                                line-height: 23px;
                            }
                        }

                        .date {
                            font-size: 22px;
                            color: #010101;
                            line-height: 23px;
                        }
                    }
                }
            }
        }
    }
}

.newsPagination {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 50px;
    width: 1200px;
    margin: 0 auto;
}

@media screen and (max-width:1200px) {

    .Interview {
        background: #ffffff;
        padding-bottom: 100px;
        padding-top: 50px;

        .interviewBox {
            width: 100%;
            margin: auto;

            .title {
                font-size: 24px;
                color: #010101;
                line-height: 34px;
                font-weight: bold;
                padding: 0 30px;
            }

            .listBox {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin-top: 50px;

                .listItem {
                    width: 100%;
                    margin-bottom: 30px;

                    img {
                        width: 100%;
                        height: 330px;
                        object-fit: cover;
                        display: block;
                    }

                    .infoBox {
                        background: #F7F7F7;
                        padding: 40px 30px 30px 30px;

                        .itemName {
                            font-size: 24px;
                            color: #010101;
                            line-height: 28px;
                            padding-bottom: 23px;
                            font-weight: bold;
                        }

                        .footBox {
                            border-top: 1px solid #888888;
                            display: flex;
                            justify-content: space-between;
                            padding-top: 24px;

                            .address {
                                font-size: 22px;
                                color: #010101;
                                line-height: 23px;
                            }

                            .date {
                                font-size: 22px;
                                color: #010101;
                                line-height: 23px;
                            }
                        }
                    }
                }
            }
        }
    }

    .newsPagination {
        width: 100%;
    }

}
</style>